import script from "./ContentPostingTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentPostingTerms.vue?vue&type=script&setup=true&lang=js"

import "./ContentPostingTerms.vue?vue&type=style&index=0&id=8c606ec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c606ec0"]])

export default __exports__